import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { KeyRound, ChevronRight, Clock, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Overview panel: shows access items still needing the client's action. Client-only. */
export default function AccessPendingPanel({ firmId }) {
  const [pending, setPending] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!firmId) return;
    axios.get(`${API}/access-requests/${firmId}`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((res) => setPending((res.data || []).filter((r) => r.status === 'requested' || r.status === 'issue')))
      .catch(() => setPending([]));
  }, [firmId]);

  if (pending.length === 0) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 soft-shadow" data-testid="overview-pending-access">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-amber-100 flex items-center justify-center"><KeyRound className="w-5 h-5 text-amber-600" /></div>
          <div>
            <h3 className="font-bold text-slate-900" style={{ fontFamily: 'Outfit' }}>Access needed</h3>
            <p className="text-xs text-amber-700">Your team is waiting on {pending.length} access {pending.length === 1 ? 'item' : 'items'}.</p>
          </div>
        </div>
        <button onClick={() => navigate('/dashboard/access')} className="inline-flex items-center gap-1 text-sm font-semibold text-amber-700 hover:text-amber-900" data-testid="overview-access-cta">
          Review <ChevronRight className="w-4 h-4" />
        </button>
      </div>
      <div className="space-y-2">
        {pending.slice(0, 4).map((p) => (
          <button key={p.id} onClick={() => navigate('/dashboard/access')} className="w-full flex items-center gap-2 text-left bg-white rounded-xl border border-amber-100 px-3 py-2.5 hover:border-amber-300 transition" data-testid={`overview-access-item-${p.platform}`}>
            {p.status === 'issue' ? <AlertTriangle className="w-4 h-4 text-red-500 flex-shrink-0" /> : <Clock className="w-4 h-4 text-amber-500 flex-shrink-0" />}
            <span className="text-sm font-medium text-slate-800">{p.platform_label}</span>
            <span className="text-xs text-slate-400 ml-auto">{p.status === 'issue' ? 'Needs attention' : 'Awaiting your action'}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
